import { dateTimeFormat } from 'helpers/DateTimeConverter';
import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

const Time = styled.div`
    display: inline-block;
`;

interface IDateTimeString extends HTMLAttributes<HTMLDivElement> {
    dateTime: string;
}

interface IDateTime extends IDateTimeString, HTMLAttributes<HTMLDivElement> {}

export function DateTImeString({ dateTime }: IDateTimeString): string {
    const monthDay = dateTimeFormat({
        dateTime,
        options: {
            month: 'long',
            day: 'numeric'
        }
    });
    const year = dateTimeFormat({
        dateTime,
        options: {
            year: 'numeric'
        }
    });

    return `${monthDay} ${year}`;
}

export default function DateString(props: IDateTime): JSX.Element {
    const { dateTime, ...rest } = props;

    return <Time {...rest} dangerouslySetInnerHTML={{ __html: DateTImeString({ dateTime }) }} />;
}
